import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetProfileCategoryDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface ProfileSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
}

export const profileCategoryForGrid = (
  profileCategory: GetProfileCategoryDto,
) => {
  return {
    key: profileCategory.id,
    values: {
      'profileCategory.name': profileCategory.name,
      'profile.name': profileCategory.profile.name,
    },
    isInactive: !profileCategory.active,
  };
};

export const ProfileCategorySearch: React.FC<ProfileSearchProps> = props => {
  const { t, tk } = useTranslation('administrationLng');

  const columns: GridColumn[] = [
    { header: t(tk.common.name), property: 'profileCategory.name' },
    { header: t(tk.administration.profile), property: 'profile.name' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="profileCategory.name"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={t(tk.administration.noProfileCategories)}
      onRowClick={props.onRowClick}
      withHistory={true}
      refresh={props.refresh}
    />
  );
};
